import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import PartsLocationDashboards from './index';

export const PartsLocationDashboard = [
  {
    'component': <PartsLocationDashboards />,
    'path': paths.PartsLocationDashboard,
  },
];
